import { useState } from "react";
import { useNavigate } from "react-router-dom";

// styles and images
import "../project/Project.css";
import "./Users.css";
import { dbDataStore, messageAndErrorStore, userStore } from "../../store/Store";
import DeleteSelected from "../../components/DeleteSelected";
import DeletePopup from "../../components/DeletePopup";

export default function UserList({ users, userRole }) {
  // global
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const currentCompany = userStore((data) => data.currentCompany);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const setUsers = dbDataStore((dbData) => dbData.setUsers);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // state
  const [docID, setDocId] = useState("");
  const [deleteTrigger, setDeleteTrigger] = useState(false);

  // other
  const controller = new AbortController();
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", "Bearer " + JwtToken);
  const requestOptions = {
    method: "PATCH",
    headers,
  };
  const navigate = useNavigate();
  
  const handleLock = (id) => {
    const requestPayload = {
      id,
      is_approved: false,
      updated_by_id: currentUser.id,
      company_id: currentCompany.qwikr_company_key,
    };

    requestOptions.body = JSON.stringify(requestPayload);
    fetch(`${process.env.REACT_APP_BACKEND}/lc/user/approval`, requestOptions)
      .then((res) => {
        if (res.status === 401) {
          setAuthStatus(false);
          navigate("/login");
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          toggleNewMessage("Something went wrong");
        } else {
          toggleNewMessage(null, "User updated");
          navigate(0);
        }
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        return;
      });
    return () => controller.abort();
  };

  const handleApprove = (id) => {
    const requestPayload = {
      id,
      is_approved: true,
      updated_by_id: currentUser.id,
      company_id: currentCompany.qwikr_company_key,
    };

    requestOptions.body = JSON.stringify(requestPayload);
    fetch(`${process.env.REACT_APP_BACKEND}/lc/user/approval`, requestOptions)
      .then((res) => {
        if (res.status === 401) {
          setAuthStatus(false);
          navigate("/login");
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          toggleNewMessage("Something went wrong");
        } else {
          toggleNewMessage(null, "User updated");
          navigate(0);
        }
      })
      .catch((_) => {
        toggleNewMessage("Something Went Wrong");
      });
    return () => controller.abort();
  };

  const getStatus = (apprv, userId, role) => {
    switch (userRole) {
      case "Account Admin":
        if (apprv && role !== "Account Admin") {
          return (
            <td>
              <button
                className="lock-button"
                onClick={() => handleLock(userId)}
              >
                Lock
              </button>
            </td>
          );
        } else if (!apprv && role !== "Account Admin") {
          return (
            <td>
              <button
                className="approve-button"
                onClick={() => handleApprove(userId)}
              >
                Approve
              </button>
            </td>
          );
        } else {
          return <td></td>;
        }
      case "Systems Admin":
        if (apprv && role !== "Account Admin" && role !== "Systems Admin") {
          return (
            <td>
              <button
                className="lock-button"
                onClick={() => handleLock(userId)}
              >
                Lock
              </button>
            </td>
          );
        } else if (!apprv && role !== "Account Admin") {
          return (
            <td>
              <button
                className="approve-button"
                onClick={() => handleApprove(userId)}
              >
                Approve
              </button>
            </td>
          );
        } else {
          return <td></td>;
        }
      default:
        if (apprv && role !== "Account Admin") {
          return <td>Approved</td>;
        } else if (!apprv && role !== "Account Admin") {
          return <td>Locked</td>;
        } else {
          return <td></td>;
        }
    }
  };

  return (
    users &&
    !users.error && (
      <div>
        <div className="display-list">
          <table className="table table-auto table-hover">
            <thead>
              <tr>
                <th>Display Name</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Approval Status</th>
                <th>Delete User</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.display_name}</td>
                  <td>{u.first_name}</td>
                  <td>{u.last_name}</td>
                  <td>{u.email}</td>
                  <td>{u.role_name}</td>
                  {getStatus(u.is_approved, u.id, u.role_name)}
                  <td className="action">
                    <div className="edits">
                      {(currentUser.role_name === "Account Admin" &&
                        currentUser.id !== u.id &&
                        u.is_approved && u.id !== currentCompany.primary_user_id) && (
                          <DeleteSelected
                            setDeleteIsTriggered={setDeleteTrigger}
                            setId={setDocId}
                            id={u.id}
                          />
                        )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {deleteTrigger && (
            <DeletePopup
              setTrigger={setDeleteTrigger}
              id={docID}
              table={"users_tbl"}
              endpoint={"user"}
              nameField={"first_name"}
              projectId={0}
              setDocId={setDocId}
              setState={setUsers}
            />
          )}
        </div>
      </div>
    )
  );
}
